import axios from 'axios'
import { API_BASE_URL } from '../utils/constants'

function authApiRoot() {
  // Merchant client is rooted at /api/merchant; impersonation lives under /api/auth
  return String(API_BASE_URL || '').replace(/\/merchant\/?$/, '')
}

/**
 * Exchange a one-time code for a merchant session JWT.
 */
export async function exchangeImpersonationCode(code) {
  const { data } = await axios.post(
    `${authApiRoot()}/auth/impersonation/exchange`,
    { code },
    { headers: { 'Content-Type': 'application/json' } }
  )
  return data
}
